const state = {
    notifications: [],
}

export default state
